// language = Hindi (hi)
import { GetStaticProps } from 'next';
import { ISTATIC_PAGE_PROPS } from '../../../../../components/cms/layout/types';
import { generateComponent } from '../../../../../components/cms/layout/util';
import {
  LANGUAGE_CODE,
  domainCode,
} from '../../../../../constants/staticPageConstants';
import {
  staticPageGenerate,
  staticPagesPath,
} from '../../../../../utils/static-pages/staticPages';

const CleartaxStaticPage = ({
  postData,
  pageType,
}: ISTATIC_PAGE_PROPS): JSX.Element => {
  return <>{generateComponent({ postData, pageType })}</>;
};

export const getStaticPaths = async () => {
  if (process.env.DEPLOYMENT_DOMAIN !== 'cleartax.in') {
    return {
      paths: [],
      fallback: false,
    };
  }

  if (
    process.env.ENABLE_CMS_PAGES === 'true' ||
    (process.env.PAGE_URL && process.env.PAGE_LANGUAGE === 'Hindi')
  ) {
    const staticPaths = await staticPagesPath(
      LANGUAGE_CODE.Hindi,
      domainCode.cleartaxIn,
      'fs-cache-dbs/cmsHindiDATA.db'
    ); //language and domainVal
    return { ...staticPaths };
  }
  return {
    paths: [],
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  if (process.env.ENABLE_CMS_PAGES === 'true' || process.env.PAGE_URL) {
    const staticPages = await staticPageGenerate(
      params,
      LANGUAGE_CODE.Hindi,
      'fs-cache-dbs/cmsHindiDATA.db'
    );
    return { ...staticPages };
  } else {
    return {
      props: {
        postData: { title: '' },
        metaData: {},
        pageType: '',
      },
    };
  }
};

export default CleartaxStaticPage;
